import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<{ mb: '0' | '8' }>()((theme, { mb }) => ({
  label: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.tokens.spacing[mb],
    transform: 'translate(0, 1.5px)',
    textOverflow: 'unset',
    whiteSpace: 'normal',
    overflow: 'unset',
  },
  required: {
    '&::after': {
      content: "'*'",
      color: theme.tokens.colors.original.brand.primary,
      marginLeft: theme.px(5), // TODO - fix нет в токенах
    },
  },
}));

export default useStyles;
